import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import type { CSSProperties, MotionValue } from "framer-motion";

type TCrossfadeParallaxLayerProps = {
	y: MotionValue<number>;
	eveningOpacity: MotionValue<number>;
	daySrc: string;
	eveningSrc: string;
	className?: string;
	imageClassName?: string;
	scale?: number;
	style?: CSSProperties;
	overlay?: React.ReactNode;
};

export function CrossfadeParallaxLayer({
	y,
	eveningOpacity,
	daySrc,
	eveningSrc,
	className,
	imageClassName = "absolute inset-0 block h-full w-full max-w-none pointer-events-none select-none object-cover object-top",
	scale = 1.04,
	style,
	overlay,
}: TCrossfadeParallaxLayerProps) {
	return (
		<motion.div className={cn("transform-gpu", className)} style={{ y, scale, ...style }} aria-hidden="true">
			<img className={imageClassName} src={daySrc} alt="" decoding="async" />
			<motion.img
				className={imageClassName}
				src={eveningSrc}
				alt=""
				decoding="async"
				style={{ opacity: eveningOpacity }}
			/>
			{overlay}
		</motion.div>
	);
}
